import React from 'react';
import { CircularProgress } from '@mui/material';
import { Box } from '@mui/system';

const Loading = () => {
  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      minHeight='50vh'
    >
      <CircularProgress />
    </Box>
  );
};

export default Loading;
